import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'downloading': false,
  'list': [],
  'fileUrl': '',
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const dealerOrdersImmobilized = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_IMMOBILIZED_DEALER_ORDERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_IMMOBILIZED_DEALER_ORDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'page': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_IMMOBILIZED_DEALER_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'page': [],
    }),
    [ActionTypes.CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.CLEAR_IMMOBILIZED_DEALER_ORDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'page': [],
      'pageSize': 20,
      'pageNumber': 0,
    }),
    [ActionTypes.DOWNLOAD_IMMOBILIZED_DEALER_ORDERS]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_SUCCESS]: (state, action) => ({
      ...state,
      'downloading': false,
      'fileUrl': action.response.data,
    }),
    [ActionTypes.DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
      'fileUrl': '',
    }),
    [ActionTypes.CLEAR_IMMOBILIZED_DEALER_ORDERS_URL_FILE]: (state, action) => ({
      ...state,
      'fileUrl': '',
    }),
  })(state, action);
};
